import LangEnum from '../../../lang/LangEnum';
import { SearchableEntityType } from '../globalSearch.types';
import { ENTITY_CONFIG } from './entityConfig';

interface GetEntityTabLabelParams {
  entityType: SearchableEntityType;
  isStore: boolean;
}

export const getEntityTabLabel = ({ entityType, isStore }: GetEntityTabLabelParams): LangEnum => {
  const { label } = ENTITY_CONFIG[entityType];
  return typeof label === 'function' ? label(isStore) : label;
};
